import { Button, STYLE_FILL } from '@eventbrite/eds-button';
import { gettext } from '@eventbrite/i18n';
import { trackAnalyticsEvent } from '@eventbrite/site-analytics';
import loadable from '@loadable/component';
import React, { useEffect, useState } from 'react';
import { GACodes } from '../../types';

export interface RSVPOptionsProps {
    eventId: string;
}

const LazyRSVPModal = loadable(() => import('./RSVPModal'));

export const RSVPOptions = ({ eventId }: RSVPOptionsProps) => {
    const [modalOpened, setModalOpened] = useState(false);
    const [userResponse, setUserResponse] = useState('');

    useEffect(() => {
        trackAnalyticsEvent({
            action: GACodes.GA_ACTION_RSVP_LOADED,
            category: GACodes.GA_CATEGORY_LISTING,
        });
    }, []);

    const handleYesClick = () => {
        trackAnalyticsEvent({
            action: GACodes.GA_ACTION_RSVP_YES_INTENT,
            category: GACodes.GA_CATEGORY_LISTING,
        });
    };
    const openMaybeModalForm = () => {
        setUserResponse('maybe');
        setModalOpened(true);
    };
    const openNoModalForm = () => {
        setUserResponse('no');
        setModalOpened(true);
    };
    const handleClose = () => {
        setModalOpened(false);
    };

    return (
        <>
            {modalOpened && (
                <LazyRSVPModal
                    response={userResponse}
                    visible={modalOpened}
                    onClose={handleClose}
                    eventId={eventId}
                />
            )}
            <div className="rsvp-component__button-section">
                <Button
                    id={`eventbrite-widget-modal-trigger-${eventId}`}
                    onClick={handleYesClick}
                    style={STYLE_FILL}
                    data-testid="checkout-link"
                >
                    {gettext('Yes')}
                </Button>
                <Button onClick={openMaybeModalForm}>{gettext('Maybe')}</Button>
                <Button onClick={openNoModalForm}>{gettext('No')}</Button>
            </div>
        </>
    );
};

export const RSVPLabel = () => {
    return (
        <h3 className="rsvp-label">
            {gettext('Are you going to this event?')}
        </h3>
    );
};
